import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
// import Wrapper from './Wrapper'
// TODO: import service worker ad get index.html to not cache
// import registerServiceWorker from '@utils/registerServiceWorker'


// global styles
import './styles/styles.scss'

// routing
import routes from './routes'

// redux store
import store from './store/store'

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCog } from '@fortawesome/free-solid-svg-icons'

library.add(faCog)

const Wrapper = () => {
	return (
		<Provider store={store}>
			{routes}
		</Provider>
	)
}

ReactDOM.render(<Wrapper />, document.getElementById('root'));

// registerServiceWorker();

// unregister all service workers (until a fix for blank index.html after new react build is found)
if(window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
  .then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
}


// WEBPACK FOOTER //
// ./src/index.js